module.exports = __webpack_public_path__ + "img/itemPic5.283d8cfd.png";